import {
  IntroductionFormValues,
  RemarkFormValues,
} from './Types/FormValuesTypes';
import {
  checkEditorMessageEn,
  checkMessageEn,
  validateSpace,
  validateSpaceTextInput,
} from './validation';

export const checkValidIntroductionTh = (
  introduction?: IntroductionFormValues
): boolean => {
  const { descriptionTh } = introduction || {};

  return validateSpace(descriptionTh);
};

export const checkValidRemarkTh = (remark?: RemarkFormValues): boolean => {
  const { descriptionTh } = remark || {};

  return validateSpaceTextInput(descriptionTh);
};

export const checkValidIntroductionEn = (
  introduction?: IntroductionFormValues
): boolean => {
  const { descriptionEn } = introduction || {};

  return (
    !descriptionEn ||
    (checkEditorMessageEn(descriptionEn) && validateSpace(descriptionEn))
  );
};

export const checkValidRemarkEn = (remark?: RemarkFormValues): boolean => {
  const { descriptionEn } = remark || {};

  return (
    !descriptionEn ||
    (checkMessageEn(descriptionEn) && validateSpaceTextInput(descriptionEn))
  );
};
